import { ClassConstructor, Exclude, plainToInstance, Transform, Type } from 'class-transformer'
import VueI18n from 'vue-i18n'

import MessageEditorWithMediaData from '../NewMessageEditors/NewMessageEditorWithMedia/types'
import {
  ActivityCondition, BoostsCondition,
  DistributionCondition, LabelsCondition,
  PossibleConditions, SentCondition,
  UsersCondition, UtmCondition
} from './DistributionEditor/DistributionConditions/types'
import { ConditionType, DistributionState } from './DistributionEditor/types'

export const subTypes: Array<{ value: ClassConstructor<DistributionCondition>, name: ConditionType }> = [
  { value: SentCondition, name: ConditionType.Sent },
  { value: ActivityCondition, name: ConditionType.Activity },
  { value: LabelsCondition, name: ConditionType.Labels },
  { value: UsersCondition, name: ConditionType.Users },
  { value: UtmCondition, name: ConditionType.Utm },
  { value: BoostsCondition, name: ConditionType.Boosts },
]

export class DistributionContent {
  @Type(() => MessageEditorWithMediaData)
  templates: Array<MessageEditorWithMediaData> = [ {
    text: '',
    attachments: [],
    buttons: [],
    pin: false,
    disable_link_preview: false,
    disable_notify: false,
    remove_previous: false,
    protect_content: false,
    remove_after: 0,
    send_after: 0,
  } ]
}

export class Distribution {
  id?: number
  description!: string
  limit!: number
  content!: DistributionContent
  time!: string | null
  timezone?: string

  @Transform(({ value }) => {
    return value.map((group: Array<any>) => {
      return group.map((cnd) => {
        const factory = subTypes.find((f) => f.name === cnd.type)

        if (factory) {
          return plainToInstance(factory.value, cnd)
        }
      })
    })
  })
  conditions!: Array<Array<PossibleConditions>>

  resetTime() {
    this.time = null
  }

  validateConditions(i18n: VueI18n) {
    if (this.conditions.length) {
      this.conditions.forEach((g, i) => {
        if (Array.isArray(g)) {
          g.forEach((c, j) => {
            if (!c.validate()) {
              throw new Error(i18n.t('distribution_conditions_validation_error_group_item', { group: i + 1, item: j + 1 }).toString())
            }
          })
        }
      })
    }
  }
}

export class FullDistribution extends Distribution {
  @Exclude({ toPlainOnly: true })
  success?: null | number

  @Exclude({ toPlainOnly: true })
  failed?: null | number

  @Exclude({ toPlainOnly: true })
  total?: null | number

  @Exclude({ toPlainOnly: true })
  state!: DistributionState

  @Exclude({ toPlainOnly: true })
  started?: string

  @Exclude({ toPlainOnly: true })
  completed?: string
}
